import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmBarrelForm from '../../../components/forms/FirearmBarrelForm';
import { useCreateFirearmBarrel } from '../../../hooks/useFirearmBarrelApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmBarrelDTO } from '../../../services/apiClient';

const FirearmBarrelCreate: React.FC = () => {
  const createFirearmBarrel = useCreateFirearmBarrel();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Barrels', href: '/admin/firearmbarrels' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FirearmBarrelDTO) => {
    try {
      await createFirearmBarrel.mutateAsync(data);
      navigate('/admin/firearmbarrels');
    } catch (error) {
      console.error('Error creating FirearmBarrel:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmbarrels"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmBarrel.Edit'
    >
        <FirearmBarrelForm
          initialValues={{} as FirearmBarrelDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/firearmbarrels')}
        />
    </AdminLayout>
  );
};

export default FirearmBarrelCreate;